module.exports = __webpack_public_path__ + "img/rf6.d67bc613.png";